import { PublicSnapshotSchema, type PublicSnapshot } from "./snapshot.js";

const sourceHealth = [
  {
    sourceId: "jolpica",
    status: "healthy" as const,
    checkedAt: "2026-08-20T12:00:00.000Z",
    lastSuccessfulAt: "2026-08-20T12:00:00.000Z",
  },
  {
    sourceId: "driver-feed",
    status: "healthy" as const,
    checkedAt: "2026-08-20T12:00:00.000Z",
    lastSuccessfulAt: "2026-08-20T11:58:00.000Z",
  },
  {
    sourceId: "press-wire",
    status: "healthy" as const,
    checkedAt: "2026-08-20T12:00:00.000Z",
    lastSuccessfulAt: "2026-08-20T11:55:00.000Z",
  },
  {
    sourceId: "organizer-feed",
    status: "healthy" as const,
    checkedAt: "2026-08-20T12:00:00.000Z",
    lastSuccessfulAt: "2026-08-20T11:50:00.000Z",
  },
];

const circuit = {
  id: "signal-ring",
  round: 12,
  name: "Signal Ring",
  city: "Testford",
  countryCode: "GB",
  coordinates: [-1.5, 52.1] as [number, number],
  status: "current" as const,
  assetState: "3d" as const,
  geometryAttribution: "Synthetic M1 fixture geometry",
  elevationAttribution: "Synthetic M1 fixture elevation",
};

const weekend = {
  id: "2026-signal-grand-prix",
  round: 12,
  name: "Signal Grand Prix",
  circuitId: circuit.id,
  timezone: "Europe/London",
  startsAt: "2026-08-21T11:00:00.000Z",
  endsAt: "2026-08-23T16:00:00.000Z",
  status: "upcoming" as const,
  sessions: [
    {
      id: "signal-practice-1",
      kind: "practice-1" as const,
      label: "Practice 1",
      startsAt: "2026-08-21T11:00:00.000Z",
      endsAt: "2026-08-21T12:00:00.000Z",
      status: "scheduled" as const,
    },
    {
      id: "signal-qualifying",
      kind: "qualifying" as const,
      label: "Qualifying",
      startsAt: "2026-08-22T14:00:00.000Z",
      endsAt: "2026-08-22T15:00:00.000Z",
      status: "scheduled" as const,
    },
    {
      id: "signal-race",
      kind: "race" as const,
      label: "Race",
      startsAt: "2026-08-23T14:00:00.000Z",
      endsAt: "2026-08-23T16:00:00.000Z",
      status: "scheduled" as const,
    },
  ],
};

export const validSnapshotFixture = PublicSnapshotSchema.parse({
  schemaVersion: 1,
  id: "snapshot-valid",
  generatedAt: "2026-08-20T12:00:00.000Z",
  staleAt: "2026-08-20T14:00:00.000Z",
  season: {
    year: 2026,
    championshipName: "Synthetic World Drivers Championship",
    rosterUpdatedAt: "2026-08-20T11:45:00.000Z",
  },
  drivers: [
    {
      id: "ada-pace",
      givenName: "Ada",
      familyName: "Pace",
      acronym: "PAC",
      permanentNumber: "7",
      constructorId: "signal-motors",
      accentColor: "#1557FF",
      active: true,
    },
    {
      id: "leo-apex",
      givenName: "Leo",
      familyName: "Apex",
      acronym: "APX",
      permanentNumber: "18",
      constructorId: "vector-racing",
      accentColor: "#F0441D",
      active: true,
    },
  ],
  locations: [
    {
      driverId: "ada-pace",
      status: "estimated",
      city: "Testford",
      countryCode: "GB",
      coordinates: [-1.5, 52.1],
      precision: "city",
      confidenceScore: 90,
      confidenceBand: "high",
      observedAt: "2026-08-20T11:00:00.000Z",
      expiresAt: "2026-08-21T11:00:00.000Z",
      evidence: [
        {
          id: "evidence-ada-direct",
          sourceId: "driver-feed",
          sourceGroupId: "ada-direct-post",
          publisher: "Ada Pace",
          title: "Public city-level appearance disclosure",
          url: "https://example.com/evidence/ada-direct",
          evidenceType: "driver-self-disclosure",
          publishedAt: "2026-08-20T11:00:00.000Z",
          observedAt: "2026-08-20T11:00:00.000Z",
          expiresAt: "2026-08-21T11:00:00.000Z",
          freshness: "fresh",
        },
      ],
      rationale: "A permitted direct disclosure identifies the city.",
      expectedNext: {
        label: "Public race-weekend appearance",
        city: "Testford",
        countryCode: "GB",
        coordinates: [-1.5, 52.1],
        startsAt: "2026-08-21T11:00:00.000Z",
        endsAt: "2026-08-23T16:00:00.000Z",
        sourceId: "organizer-feed",
        sourceUrl: "https://example.com/schedule/signal-grand-prix",
      },
    },
    {
      driverId: "leo-apex",
      status: "unknown",
      precision: "city",
      evidence: [],
      rationale: "No reliable current estimate is available.",
    },
  ],
  weekend,
  standings: {
    publishedAt: "2026-08-19T18:00:00.000Z",
    sourceId: "jolpica",
    drivers: [
      {
        position: 1,
        driverId: "ada-pace",
        constructorId: "signal-motors",
        points: 210,
        wins: 5,
      },
      {
        position: 2,
        driverId: "leo-apex",
        constructorId: "vector-racing",
        points: 196,
        wins: 4,
      },
    ],
    constructors: [
      {
        position: 1,
        constructorId: "signal-motors",
        name: "Signal Motors",
        accentColor: "#1557FF",
        points: 388,
        wins: 6,
      },
      {
        position: 2,
        constructorId: "vector-racing",
        name: "Vector Racing",
        accentColor: "#F0441D",
        points: 371,
        wins: 5,
      },
    ],
  },
  circuits: [circuit],
  sourceHealth,
});

export const staleSnapshotFixture = PublicSnapshotSchema.parse({
  ...validSnapshotFixture,
  id: "snapshot-stale",
  generatedAt: "2026-08-18T10:00:00.000Z",
  staleAt: "2026-08-18T12:00:00.000Z",
  locations: validSnapshotFixture.locations.map((location) =>
    location.status === "unknown"
      ? location
      : {
          ...location,
          observedAt: "2026-08-18T09:00:00.000Z",
          expiresAt: "2026-08-19T09:00:00.000Z",
          evidence: location.evidence.map((evidence) => ({
            ...evidence,
            publishedAt: "2026-08-18T09:00:00.000Z",
            observedAt: "2026-08-18T09:00:00.000Z",
            expiresAt: "2026-08-19T09:00:00.000Z",
          })),
        },
  ),
});

export const unknownDriverSnapshotFixture = PublicSnapshotSchema.parse({
  ...validSnapshotFixture,
  id: "snapshot-unknown-driver",
  locations: validSnapshotFixture.drivers.map((driver) => ({
    driverId: driver.id,
    status: "unknown" as const,
    precision: "city" as const,
    evidence: [],
    rationale: "No reliable current estimate is available.",
  })),
});

export const conflictedSnapshotFixture = PublicSnapshotSchema.parse({
  ...validSnapshotFixture,
  id: "snapshot-conflicted",
  locations: [
    {
      driverId: "ada-pace",
      status: "unknown",
      precision: "city",
      rationale:
        "Equally credible current evidence identifies different cities.",
      evidence: [
        validSnapshotFixture.locations[0]?.evidence[0],
        {
          id: "evidence-ada-conflict",
          sourceId: "press-wire",
          sourceGroupId: "independent-conflict-report",
          publisher: "Synthetic Press Wire",
          title: "Conflicting city-level report",
          url: "https://example.com/evidence/ada-conflict",
          evidenceType: "reputable-press",
          publishedAt: "2026-08-20T11:05:00.000Z",
          observedAt: "2026-08-20T11:05:00.000Z",
          expiresAt: "2026-08-21T11:05:00.000Z",
          freshness: "fresh",
        },
      ].filter((evidence) => evidence !== undefined),
    },
    validSnapshotFixture.locations[1],
  ],
});

export const malformedSnapshotFixture: unknown = {
  ...validSnapshotFixture,
  id: "snapshot-malformed",
  locations: [
    {
      ...validSnapshotFixture.locations[0],
      confidenceScore: 79,
      confidenceBand: "high",
      coordinates: [200, 95],
    },
  ],
};

export function createRepresentativeSnapshotFixture(): PublicSnapshot {
  const constructors = Array.from({ length: 10 }, (_, index) => ({
    position: index + 1,
    constructorId: `constructor-${String(index + 1)}`,
    name: `Synthetic Constructor ${String(index + 1)}`,
    accentColor: index % 2 === 0 ? "#1557FF" : "#F0441D",
    points: 400 - index * 19,
    wins: Math.max(0, 8 - index),
  }));
  const drivers = Array.from({ length: 20 }, (_, index) => ({
    id: `driver-${String(index + 1)}`,
    givenName: `Driver${String(index + 1)}`,
    familyName: `Fixture${String(index + 1)}`,
    acronym: `${String.fromCharCode(65 + index)}DR`,
    permanentNumber: String(index + 1),
    constructorId:
      constructors[index % constructors.length]?.constructorId ??
      "constructor-1",
    accentColor: index % 2 === 0 ? "#1557FF" : "#F0441D",
    active: true,
  }));
  const locations = drivers.map((driver, index) => {
    if (index % 5 === 4) {
      return {
        driverId: driver.id,
        status: "unknown" as const,
        precision: "city" as const,
        evidence: [],
        rationale: "No reliable current estimate is available.",
      };
    }

    return {
      driverId: driver.id,
      status: "estimated" as const,
      city: `Fixture City ${String(index + 1)}`,
      countryCode: index % 2 === 0 ? "GB" : "IT",
      coordinates: [-5 + index * 0.5, 40 + index * 0.4] as [number, number],
      precision: "city" as const,
      confidenceScore: 78,
      confidenceBand: "medium" as const,
      observedAt: "2026-08-20T11:00:00.000Z",
      expiresAt: "2026-08-21T11:00:00.000Z",
      evidence: [
        {
          id: `evidence-${String(index + 1)}-press`,
          sourceId: "press-wire",
          sourceGroupId: `report-${String(index + 1)}`,
          publisher: "Synthetic Press Wire",
          title: `Current city report for fixture driver ${String(index + 1)}`,
          url: `https://example.com/evidence/driver-${String(index + 1)}`,
          evidenceType: "reputable-press" as const,
          publishedAt: "2026-08-20T11:00:00.000Z",
          observedAt: "2026-08-20T11:00:00.000Z",
          expiresAt: "2026-08-21T11:00:00.000Z",
          freshness: "fresh" as const,
        },
        {
          id: `evidence-${String(index + 1)}-associate`,
          sourceId: "driver-feed",
          sourceGroupId: `associate-${String(index + 1)}`,
          publisher: "Synthetic Associate Feed",
          title: `Independent contextual evidence ${String(index + 1)}`,
          url: `https://example.com/evidence/associate-${String(index + 1)}`,
          evidenceType: "associate-context" as const,
          publishedAt: "2026-08-20T11:10:00.000Z",
          observedAt: "2026-08-20T11:10:00.000Z",
          expiresAt: "2026-08-20T23:10:00.000Z",
          freshness: "fresh" as const,
        },
      ],
      rationale: "Independent permitted sources identify the same city.",
    };
  });
  const circuits = Array.from({ length: 24 }, (_, index) => ({
    id: `circuit-${String(index + 1)}`,
    round: index + 1,
    name: `Synthetic Circuit ${String(index + 1)}`,
    city: `Circuit City ${String(index + 1)}`,
    countryCode: index % 2 === 0 ? "GB" : "IT",
    coordinates: [-10 + index, 30 + index * 0.8] as [number, number],
    status:
      index < 11
        ? ("past" as const)
        : index === 11
          ? ("current" as const)
          : ("upcoming" as const),
    assetState: index % 7 === 0 ? ("2d-fallback" as const) : ("3d" as const),
    geometryAttribution: "Synthetic M1 fixture geometry",
    elevationAttribution: "Synthetic M1 fixture elevation",
  }));

  return PublicSnapshotSchema.parse({
    ...validSnapshotFixture,
    id: "snapshot-representative",
    drivers,
    locations,
    standings: {
      ...validSnapshotFixture.standings,
      drivers: drivers.map((driver, index) => ({
        position: index + 1,
        driverId: driver.id,
        constructorId: driver.constructorId,
        points: 300 - index * 7.5,
        wins: Math.max(0, 6 - Math.floor(index / 3)),
      })),
      constructors,
    },
    circuits,
    weekend: {
      ...weekend,
      circuitId: circuits[0]?.id,
    },
  });
}
